import { createApp } from 'vue';
import { router } from './router';
import AppReservation from './AppReservation.vue';
import './modules/useValidator';

createApp(AppReservation).use(router).mount('#reservation');
